import API from "./API";

export class ReportService {

    static getMyBranches(){
        return  API.ax.get(`v1/auth/mybranch`).catch(e=>console.log(e))
    }

    static  getMonthlyReport(oid,data0,data1,method){
        return  API.ax.get(`v2/report/monthly?date0=${data0}&date1=${data1}&oid=${oid}&method=${method}`).catch(e=>console.log(e))
    }
}